import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { AppViews } from '../../helpers/enums';
import { filterResults } from 'src/app/store/app.actions';
import { MainViewStore, MainViewState } from '../../helpers/types';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styles: ['.disabled { pointer-events: none; }']
})
export class SearchComponent {
  @Input() placeholder = '';
  @Input() searchFieldName: string;
  @Input() state: Observable<MainViewState>;
  @Input() view: AppViews;

  constructor(private store: Store<MainViewStore>) {}

  search(searchText: string): void {
    this.state.pipe(take(1)).subscribe((state: MainViewState) => {
      const params = {
        ...state.params,
        [this.searchFieldName]: searchText,
        offset: 0
      };
      this.store.dispatch(filterResults({ params, appView: this.view }));
    });
  }
}
